module.exports = __webpack_public_path__ + "static/media/loyalty-banner.c52821a1.png";